<template>
  <v-container fluid>
    <v-form @submit.prevent="submit"
            :disabled="form.busy">

      <team-form-info :form="form">
      </team-form-info>

      <v-card>
        <v-card-actions>
          <v-btn color="primary">
            Save Changes
          </v-btn>
        </v-card-actions>
      </v-card>

    </v-form>
  </v-container>
</template>
<script>
import {mapGetters} from 'vuex';
import {Form} from 'vform';
import TeamFormInfo from "./form/team-form-info";
import teamService from "../../../../ml/services/teamService";
import metaService from "../../services/metaService";

export default {
  metaInfo() {
    this.$store.commit('setTitle', `Edit Team`);
    return {
      title: this.$store.getters.title,
    }
  },
  components: {TeamFormInfo},
  data() {
    return {
      form: new Form({
        name: '',
        owner_id: '',
      }),
      team: null,
    }
  },
  computed: {
    ...mapGetters([
      'team',
      'user',
    ])
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.team = await teamService.get(this.user.current_team_id)
      this.initForm();
    },
    initForm() {
      this.form.name = this.team.name;
      this.form.owner_id = this.team.owner_id;
    },
    submit() {

    }
  }
}
</script>
